import defaultValue from "./authSlice";

export default defaultValue;
export * from "./authSlice";
